'use strict';

var AppState = require('app_state');
var AbstractFormView = require('components/common/views/abstract_form_view');
var LoginView = require('components/account/views/login_view');
var i18n = require('utils/i18n');

var MFAView = LoginView.extend({
    template: require('components/account/templates/mfa'),

    events: {
        'click button.js-login': 'loginClicked',
        'click span.js-lang': 'languageClicked',
        'click a#js-terms': 'termsClicked',
        'click a#js-gdpr': 'gdprClicked',
        'click a#js-imprint': 'imprintClicked',
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.user = options.user;

        AbstractFormView.prototype.initialize.apply(this, [
            {
                inputFields: {
                    'js-email': {},
                    'js-password': {},
                    'js-code': {},
                },
                errors: options.errors,
                formData: options.formData,
            },
        ]);
    },

    onAttach: function () {
        $('#js-code-input').focus();
    },

    serializeData: function () {
        var data = AbstractFormView.prototype.serializeData.apply(this, arguments);

        data.lang = i18n.language.toUpperCase();
        data.isSubdomain = AppState.isSubdomain;

        data.attempts = this.attempts;
        data.locked = this.locked;

        data.username = this.options.user.email;

        return data;
    },

    loginClicked: function (e) {
        e.preventDefault();

        var self = this;

        var loginData = Backbone.Syphon.serialize(this);
        loginData['password'] = this.options.formData.password;
        loginData['remember_me'] = this.options.formData.remember_me;

        this.setActivation(loginData);
        this.controller.authenticate(loginData);
    },
});

module.exports = MFAView;
